import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { ModPrepTimeService } from 'src/app/observer-view/preptimes/mod-prep-time.service';
import { PackService } from '../services/PackService';

type modPrepTime = {
  pack: PRM.IpadPackage,
  preptimes: PRM.PrepTimeEntry[],
  prepevents: PRM.Event[]
}

export const modPrepTimeResolver: ResolveFn<modPrepTime> = async (route: any) => {
  const service = inject(ModPrepTimeService);
  const packService = inject(PackService);
  const preptimes = await service.getPrepTimesAsModerator();
  const pack = await packService.getCurrentPackage();
  const prepevents = await service.getPrepTimeEvents();
  return { pack, preptimes, prepevents };
};